import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moveNumberToFront'
})
export class MoveNumberToFrontPipe implements PipeTransform {
  transform(value: string): string {
    const match = value.match(/(.*?)(\d+)\s*$/);
    if (!match) return value;

    const [, text, number] = match;
    return `${number} ${text.trim()}`;
  }
}
